import React from 'react';
import BillingDashboardSection from '../../../sections/AdminDashboard/Finance/FinanceDashboard';

const BillingDashboard = () => {
  return <BillingDashboardSection />;
};

export default BillingDashboard;


